const PublicLayout = ({ children }: any) => {
  return <div>{children}</div>;
};

export default PublicLayout;
